export type OpenPixConfig = {
  appID: string | null;
};

export type OpenPixUser = {
  email?: string;
  taxID?: string;
  phone?: string;
};

export type OpenPixCustomer = {
  email?: string;
  taxID?: string;
  phone?: string;
};

export type OpenPixCharge = {
  value: number;
  correlationID?: string;
  description?: string;
};

export type OpenPixState = {
  isOpen: boolean;
  config: OpenPixConfig;
  user?: OpenPixUser | null;
  customer?: OpenPixCustomer;
  // move this to charge
  value?: number;
  correlationID?: string;
  description?: string;
  closeOnSuccess?: boolean;
  alwaysShowQrCode?: boolean;
  allowSimulatePayment?: boolean;
};
let openPixState: OpenPixState = {
  isOpen: false,
  config: {
    appID: null,
  },
};

export const getOpenPixState = (): OpenPixState => {
  return openPixState;
};

export const setOpenPixState = (newState: Partial<OpenPixState>) => {
  openPixState = {
    ...openPixState,
    ...newState,
  };

  return openPixState;
};

// websocket listener to communication with end user
type Listener = (...args: any[]) => void;

let listeners: Listener[] = [];

export const addEventListener = (newListener: Listener): (() => void) => {
  listeners.push(newListener);

  const unsubscribe = () => {
    listeners = listeners.filter((l) => l !== newListener);
  };

  return unsubscribe;
};

export const getEventListeners = () => {
  return listeners;
};
